import { render, staticRenderFns } from "./ClientEditCommentDialog.vue?vue&type=template&id=46b021a6&scoped=true"
import script from "./ClientEditCommentDialog.vue?vue&type=script&lang=js"
export * from "./ClientEditCommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b021a6",
  null
  
)

export default component.exports